import { NewUserEditorState } from 'types/state';
import { createNewUserFormValues } from 'utils/createNewUserFormValues';

export const createNewUserEditorState = (): NewUserEditorState => ({
  formValues: createNewUserFormValues(),
  submited: false,
  submitDidSucceed: false
});
